import React, { useRef } from 'react'
import { Box, Button, Typography } from '@mui/material'
import BackIcon from '@mui/icons-material/ArrowBack'
import axios from 'axios'
import useRouter from '../hooks/useRouter'
import useAccount from '../hooks/useAccount'
// TODO: rewrite with v2 API endpoints (Task 10)
// import useAgentSession from '../hooks/useAgentSession'
import { ArtifactViewer, ArtifactInfo } from '../agent'
import { API_BASE_URL } from '../constants/system'

export default function AgentArtifactsPage() {
  const router = useRouter()
  const account = useAccount()
  const customer = router.params.customer || account.customer?.name || ''
  const sessionId = router.params.sessionId as string

  // TODO: rewrite with v2 API endpoints (Task 10)
  const session: null = null
  const artifacts: ArtifactInfo[] = []
  const resumeAttemptedRef = useRef('')

  if (sessionId && !session && resumeAttemptedRef.current !== sessionId) {
    resumeAttemptedRef.current = sessionId
  }

  const handleBack = () => {
    router.navigate('agent-session', { customer, sessionId })
  }

  return (
    <Box sx={{ height: 'calc(100vh - 64px)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <Box
        sx={{
          p: '8px 16px',
          borderBottom: '1px solid #e5e7eb',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          backgroundColor: 'white',
        }}
      >
        <Button
          size="small"
          startIcon={<BackIcon />}
          onClick={handleBack}
          color="info"
          sx={{ textTransform: 'none' }}
        >
          Back to chat
        </Button>
        <Typography sx={{ fontWeight: 600 }}>
          Artifacts ({artifacts.length})
        </Typography>
      </Box>
      <Box sx={{ flex: 1, overflow: 'hidden' }}>
        <ArtifactViewer
          artifacts={artifacts}
          sessionId={sessionId}
          inline
          apiBaseUrl={API_BASE_URL}
          authHeader={axios.defaults.headers.common['Authorization'] as string | undefined}
          customer={customer}
        />
      </Box>
    </Box>
  )
}
